import { AngleRightIcon, IconSize, OSmallParagraph } from '@lifechurch/react-ion';
import React, { FC } from 'react';
import { useModalContext } from '@lib/modalContext';
import { ModalType } from '@components/Modal';
import { ServiceDataMoment } from '../AnalyticsServiceGrid';
import { ClickableTableRow } from './ClickableTableRow';
import { NonClickableTableRow } from './NonClickableTableRow';

interface TableRowProps {
  title: string;
  content: string | undefined | null;
  postTime: string;
  impressions: number;
  interactions: number;
  deleted: boolean;
  clickable: boolean;
  onClick?: () => void;
}

const BaseTableRow: FC<TableRowProps> = ({
  clickable,
  content,
  deleted,
  impressions,
  interactions,
  onClick,
  postTime,
  title,
}) => {
  const Element = clickable ? ClickableTableRow : NonClickableTableRow;
  // TODO: Translate here
  return (
    <Element onClick={clickable ? onClick : undefined}>
      <OSmallParagraph>{title}</OSmallParagraph>
      <OSmallParagraph>{content}</OSmallParagraph>
      <OSmallParagraph>
        {postTime} {deleted && '(deleted)'}
      </OSmallParagraph>
      <OSmallParagraph>{impressions}</OSmallParagraph>
      <OSmallParagraph>{interactions}</OSmallParagraph>
      <OSmallParagraph>
        {title === 'Quote' && <AngleRightIcon size={IconSize.SM} />}
      </OSmallParagraph>
    </Element>
  );
};

interface Props {
  moment: ServiceDataMoment;
}

const TableRow: FC<Props> = ({ moment }) => {
  const { openModal } = useModalContext();

  const onRowClick = (moment: ServiceDataMoment): void => {
    // TODO: Fix this potentially
    if (moment.title !== 'Quote' && moment.title !== 'Image') return;

    openModal({
      type: ModalType.ANALYTICS_SERVICE_MOMENT_DETAIL_METRICS,
      data: {
        moment,
      },
    });
  };

  return (
    <BaseTableRow
      clickable={moment.title === 'Quote' || moment.title === 'Image'}
      content={moment.content}
      deleted={moment.deleted}
      impressions={moment.impressions}
      interactions={moment.interactions}
      key={moment.id}
      onClick={() => onRowClick(moment)}
      postTime={moment.postTime}
      title={moment.title}
    />
  );
};

export { TableRow };
